const Reg = {
    isPhone: /^1\d{10}$/,
    isPhoneInput: /^\d{0,11}$/,
    isEmail: /^([A-Za-z0-9_\-\.])+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
    isPassword: /^[a-zA-Z\d!#$%&*,.:;<>?@^_`~]{8,16}$/,
    isSmsCode: /^\d{6}$/,
    isiPad: /ipad/i,
    isiOS: /iPhone/i,
    isAndroid: /android/i,
    isMobile: /mobile/i,
    isVivoBrowser: /vivoBrowser/i,
    isMiUIBrowser: /miuiBrowser/i,
    isQuarkBrowser: /quark/i,
}

export default Reg
